import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Skeleton, Alert } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { modalEdit, modalConfirm } from "../../features/modal/modalSlice";

const IconEdit = ({ dispatch, id }) => {
    return(
        <TableCell>
            <IconButton color="primary" onClick={() => dispatch(modalEdit(id))}>
                <Edit />
            </IconButton>
        </TableCell>
    )
}

const IconRemove = ({ dispatch, id, item }) => {
    return(
        <TableCell>
            <IconButton color="secondary" onClick={() => dispatch(modalConfirm({ id, item }))}>
                <Delete />
            </IconButton>
        </TableCell>
    )
}

const CustomTable = ({ data, headers, edit = false, remove = false, showFound = true }) => {
    const { isLoading } = useSelector(state => state.progress)
    const dispatch = useDispatch();
    if(isLoading) return <Skeleton animation="wave" variant="rounded" height={50} />
    if(!data.length) return <Alert severity="warning">No se encontraron registros</Alert>
    return(
        <TableContainer sx={{ pt: '1em' }}>
            { showFound && <Alert severity="success">Total: <b>{data.length}</b></Alert> }
            <Table>
                <TableHead>
                    <TableRow>
                        { headers.map(({ name }, i) =>  i === 0 ? <TableCell key={i} align="center"> {name} </TableCell> : <TableCell key={i}> {name} </TableCell>) }
                        { edit && <TableCell></TableCell> }
                        { remove && <TableCell></TableCell> }
                    </TableRow>
                </TableHead>
                <TableBody>
                    { data.map(d => (
                        <TableRow key={d.id}>
                            {headers.map(({ ref }, i) => i === 0 ? <TableCell key={i} align="center"><b>{d[ref]}</b></TableCell> : <TableCell key={i}>{d[ref]}</TableCell> )}
                            {edit && <IconEdit dispatch={dispatch} id={d.id} />}
                            {remove && <IconRemove dispatch={dispatch} id={d.id} item={d.nombre} /> }
                        </TableRow>
                    )) }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default CustomTable;